// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Ef6u","productName":"Table_productName__q2xMi"};